import React, { useState } from "react";
import {v4 as uuidv4} from 'uuid';

import { OPEN_ADVANCED_SEARCH } from "../../../../auto/js/events/Gui";
import { getServiceUri, pojoMetadata } from "../../../../auto/js/metadata";

import { rest, t } from "../../../../auto/js/services";
import { createTableComponent } from "../../../../auto/js/widgets/TableComponent"
import { Checkbox, FormControlLabel } from "@mui/material";
import Facets from "../../widgets/Facets";
import {
    getOrderBy,
    getOrderDirection,
    getDefaultFilter,
    getErrorList,
    transformAdvancedSearchData,
    advancedSearchfields,
    getRowActions,
    getContext,
    filterDataLogic,
    getDataEndpoint,
    countDataEndpoint
} from "../../../../main/js/lists/signatureRequest/SignatureRequestListCommon.jsx";


export const signatureRequestListFields = [
    {
        title: "ID",
        field: "id",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Parties",
        field: "parties",
    },
    {
        title: "Status",
        field: "status",
    },
    {
        title: "Actions",
        field: "actions",
        render: (rowData) => getRowActions(rowData)
    }
]

const SignatureRequestListPage = ({uuid, gui, defaultFilter, searchData}) => {
    const [errorList, setErrorList] = useState([]);
    const [selectAllStatus, setSelectAllStatus] = useState(false);
    const [selectAllError, setSelectAllError] = useState(false);
    const [advancedSearchData, setAdvancedSearchData] = useState(searchData);
    let SignatureRequestTable = createTableComponent(signatureRequestListFields);

    const onFacetChange = (key, value) => {
        switch(key) {
            case ("selectAllStatus"):
            	setSelectAllStatus(value.target.checked);
				break;
        }
    }
    const buildData = async (query) => {
        let filter = query;
        let data;
        filter["signature-request-document-dto"] = (getDefaultFilter)?getDefaultFilter():defaultFilter?defaultFilter:{};
        filter["signature-request-document-dto"]["draft"] = false;
        filter['and'] = true;
        filter["order-by"] = getOrderBy();
        if (advancedSearchData)
            filter["query"] = advancedSearchData;
        filter["order-direction"] = (getOrderDirection)?getOrderDirection():null;
        filter.offset = query.page * query.pageSize;
        if (query.search && query.search!='') {
            pojoMetadata["signature-request"].columns.forEach(element => {
                if(element.type=='text' ){
                    filter["signature-request-document-dto"][element.key]= query.search;
                }
            });
            filter['and'] = false;
            filter.fuzziness = "AUTO";
        }
        return await getData(filter).then(response => {
           return filterData(response, gui).then((data) => {
            return countData(filter).then((count) => {return {data: data, totalCount: count, page: query.page}})
           })
        });
    }

    const onErrorFacetChange = (key, value) => {
        let list = _.clone(errorList);
        if (key === "selectAllError") {
            if (value.target.checked)
                list = selectAllErrors();
            else
                list = [];
            setErrorList(list);
            setSelectAllError(value.target.checked)
        }
        if (value.target.checked && !list.includes(key)) {
            list.push(key);
            setErrorList(list);
        }
        else if (!value.target.checked && list.includes(key)) {
            let index = list.indexOf(key);
            list.splice(index, 1);
            setErrorList(list);
        }
    }

    const getErrorCodeFacets = () => {
      let list = [{key: "selectAllError", value: selectAllError, label: t`select/deselect all`, separator: true}];
        getErrorList().forEach(error => {
            list.push({key: error, value: errorList.includes(error), label: t(error)});

        });
        return list;
    }

    const onAdvancedSearchSubmit = (data) => {
        let dto = transformAdvancedSearchData(data);
        setAdvancedSearchData(dto);
    }

    const buildFacets = (key, value, label, handleChange) => {
        return (
            <>
            <FormControlLabel
            control={<Checkbox
              checked={value}
              onChange={(event) => handleChange(key, event)}
              color="primary"
              value={value}
            />
            }
            label={label}
            style={{width: '100%'}}
            />
            </>
        )
    }

    return (
        <div>
            
            {(getErrorList) && <Facets title={t`Errors`} facets={getErrorCodeFacets()} facetsComponents={(key, value) => buildFacets(key, value, t(key), onErrorFacetChange)} />}
            <SignatureRequestTable key={uuid} loadData={async (query) => buildData(query)} advancedSearchFields={advancedSearchfields} onSubmit={onAdvancedSearchSubmit}/>
    	</div>
    )
}

export const displaySignatureRequestList = (gui, defaultFilter, advancedSearchData) => {
	const readSignatureRequestList = () => {
    let uuid = uuidv4();
		return {
			uuid, view: () => <SignatureRequestListPage gui={gui} key={uuid} defaultFilter={defaultFilter} searchData={advancedSearchData}/>, getContext: (getContext) && getContext
		};
	}
	gui.goTo(readSignatureRequestList)
}

export const displaySignatureRequestAdvancedSearch = (gui) => {
    let advancedSearchFilters = {fields: advancedSearchfields, name: t`SignatureRequest`, onSubmit: (filter) => onAdvancedSearchSubmit(filter, gui)};
	OPEN_ADVANCED_SEARCH.publish(advancedSearchFilters);
}

const selectAllErrors = () => {
    let list = ["selectAllError"];
    getErrorList().forEach(error => {
            list.push(error);
    });
    return list;
}

const onAdvancedSearchSubmit = (filter, gui) => {
    displaySignatureRequestList(gui, transformAdvancedSearchData(filter));
}

export const getData = async (filter) => {
	 if (getDataEndpoint)
        return await getDataEndpoint(filter);
    else {
		let searchEndpoint = (filter.query) ? "signature-request/advanced-search":"signature-request/search-document/"
    	return await rest.request(getServiceUri() + searchEndpoint, "POST", filter);
	}
}

export const countData = async (filter) => {
	if (countDataEndpoint)
        return await countDataEndpoint(filter);
    else {
		let countEndpoint = (filter.query) ? "signature-request/count/advanced-search":"signature-request/count-document/"
    	return await rest.request(getServiceUri() + countEndpoint, "POST", filter);
	}
}

export const filterData = async (defaultRows, gui) => {
	let token = await rest.getToken(getServiceUri() + 'token/get-auth-code');
	let rows = (filterDataLogic)?filterDataLogic(defaultRows, token):defaultRows;
    const newRows = [];
    for (let i in rows) {
        let row = rows[i];
        row.gui = gui;
        newRows.push(row);
    };
    return newRows;
}